import { RefObject, useEffect, useState } from 'react';

type UseIsInViewportParams = {
  // Scroll container to measure against; defaults to the browser viewport
  root?: RefObject<Element | null>;
};

/**
 * useIsInViewport tracks whether a target element is currently within
 * its scroll container via IntersectionObserver.
 */
export function useIsInViewport({ root }: UseIsInViewportParams = {}) {
  const [target, setTarget] = useState<Element | null>(null);
  const [isInViewport, setIsInViewport] = useState(false);

  useEffect(() => {
    if (!target) {
      setIsInViewport(false);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => setIsInViewport(entry?.isIntersecting ?? false),
      { root: root?.current ?? null },
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, [target, root]);

  return { setTargetRef: setTarget, target, isInViewport };
}
